
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

const activeClass = 'g-active'


function highlightAnchor(entries) {
    entries.forEach(entry => {
        const id = entry.target.getAttribute('id');
        const selector = `nav li a[href="#${id}"]`
        const anchor = document.querySelector(selector)

        if (!anchor) {
            console.log('nav-hl: no anchors for section#' + id)
            return
        }

        if (entry.intersectionRatio > 0) {
            anchor.classList.add(activeClass)
            anchor.parentElement.classList.add(activeClass)
        } else {
            anchor.classList.remove(activeClass)
            anchor.parentElement.classList.remove(activeClass)
        }
    });
}

function fixSidebar(entries) {
    const e1 = entries[0]
    const sidebar = document.querySelector('.aside-1')
    if (!sidebar) { return; }
    if (e1.intersectionRatio < 0.01) {
        sidebar.classList.add('aside-1--fixed')
    } else {
        sidebar.classList.remove('aside-1--fixed')
    }
}

const sectionObserver = new IntersectionObserver(highlightAnchor);
const heroObserver = new IntersectionObserver(fixSidebar);


export function navHighlight() {
    console.log('nav-hl: init')
    // Track all sections that have an `id` applied
    document.querySelectorAll('section[id]').forEach((section) => {
        sectionObserver.observe(section);
    });

    document.querySelectorAll('.page3__hero').forEach((hero) => {
        heroObserver.observe(hero);
    });
}


